import Vuex from 'vuex';

import {setupAxiosInterceptors} from '@/shared/config/axios-interceptor';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faSort } from '@fortawesome/free-solid-svg-icons/faSort';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faHdd } from '@fortawesome/free-solid-svg-icons/faHdd';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart';
import { faList } from '@fortawesome/free-solid-svg-icons/faList';
import { faTasks } from '@fortawesome/free-solid-svg-icons/faTasks';
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons/faSignInAlt';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faThList } from '@fortawesome/free-solid-svg-icons/faThList';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus';
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons/faAsterisk';
import { faFlag } from '@fortawesome/free-solid-svg-icons/faFlag';
import { faBell } from '@fortawesome/free-solid-svg-icons/faBell';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faRoad } from '@fortawesome/free-solid-svg-icons/faRoad';
import { faCloud } from '@fortawesome/free-solid-svg-icons/faCloud';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faAlignLeft } from '@fortawesome/free-solid-svg-icons/faAlignLeft'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { faServer } from '@fortawesome/free-solid-svg-icons/faServer';
import { faFileAlt} from '@fortawesome/free-solid-svg-icons/faFileAlt';
import { faSortUp} from '@fortawesome/free-solid-svg-icons/faSortUp';
import { faSortDown} from '@fortawesome/free-solid-svg-icons/faSortDown';
import { faFilter} from '@fortawesome/free-solid-svg-icons/faFilter';
import { faCalculator} from '@fortawesome/free-solid-svg-icons/faCalculator';
import { faDatabase} from '@fortawesome/free-solid-svg-icons/faDatabase';
import { faCheck} from '@fortawesome/free-solid-svg-icons/faCheck';
import { faEllipsisH} from "@fortawesome/free-solid-svg-icons/faEllipsisH";
import { faCircle} from "@fortawesome/free-solid-svg-icons/faCircle";
import { faPrint} from "@fortawesome/free-solid-svg-icons/faPrint";
import { faExternalLinkSquareAlt} from "@fortawesome/free-solid-svg-icons/faExternalLinkSquareAlt";
import { faEnvelope} from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faCalendarAlt} from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import { faHistory } from "@fortawesome/free-solid-svg-icons/faHistory";
import {faMoneyBillAlt} from "@fortawesome/free-solid-svg-icons/faMoneyBillAlt";
import {faFileUpload} from "@fortawesome/free-solid-svg-icons/faFileUpload";

import Vuelidate from 'vuelidate';
import Vue2Filters from 'vue2-filters';
import VueCookie from 'vue-cookie';

import * as filters from '@/shared/date/filters';

export function initVueApp(vue) {
    vue.use(VueCookie);
    vue.use(Vuelidate);
    vue.use(Vue2Filters);
    setupAxiosInterceptors(() => console.log('Unauthorized!'));
    filters.initFilters();
}

export function initFortAwesome(vue) {
    library.add(
        faSort,
        faEye,
        faSync,
        faBan,
        faTrash,
        faArrowLeft,
        faSave,
        faPlus,
        faPencilAlt,
        faUser,
        faTachometerAlt,
        faHeart,
        faList,
        faTasks,
        faBook,
        faHdd,
        faClock,
        faSignInAlt,
        faSignOutAlt,
        faWrench,
        faThList,
        faUserPlus,
        faAsterisk,
        faFlag,
        faBell,
        faHome,
        faRoad,
        faCloud,
        faTimesCircle,
        faSearch,
        faBars,
        faTimes,
        faAlignLeft,
        faChevronLeft,
        faChevronRight,
        faServer,
        faFileAlt,
        faSortUp,
        faSortDown,
        faFilter,
        faCalculator,
        faDatabase,
        faCheck,
        faEllipsisH,
        faCircle,
        faPrint,
        faExternalLinkSquareAlt,
        faEnvelope,
        faCalendarAlt,
        faHistory,
        faMoneyBillAlt,
        faFileUpload
    );
}

export function initVueXStore(vue) {
    vue.use(Vuex);
    return new Vuex.Store({
        state: {
            dismissSecs: 0,
            dismissCountDown: 0,
            alertType: '',
            alertMessage: {},
            authenticated: false,
            userIdentity: null,
            logon: false
        },
        mutations: {
            initAlert(state) {
                state.dismissSecs = 0;
                state.dismissCountDown = 0;
                state.alertType = '';
                state.alertMessage = {};
            },
            setAlertType(state, alertType) {
                state.alertType = alertType;
            },
            setAlertMessage(state, alertMessage) {
                state.dismissSecs = 5;
                state.dismissCountDown = 5;
                state.alertMessage = alertMessage;
            },
            countDownChanged(state, newCountDown) {
                state.dismissCountDown = newCountDown;
            },
            authenticate(state) {
                state.logon = true;
            },
            authenticated(state, identity) {
                state.userIdentity = identity;
                state.authenticated = true;
                state.logon = false;
            },
            logout(state) {
                state.userIdentity = null;
                state.authenticated = false;
                state.logon = false;
            }
        },
        getters: {
            dismissSecs: state => state.dismissSecs,
            dismissCountDown: state => state.dismissCountDown,
            alertType: state => state.alertType,
            alertMessage: state => state.alertMessage,
            logon: state => state.logon,
            user: state => state.userIdentity,
            authenticated: state => state.authenticated,
        }
    });
}
